'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./BackgroundImage.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackgroundImage = function BackgroundImage(_ref) {
    var className = _ref.className,
        source = _ref.source,
        children = _ref.children,
        style = _ref.style;

    var styles = _extends({}, style, {
        backgroundImage: source && 'url(' + source + ')'
    });

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('BackgroundImage', className), style: styles },
        children
    );
};

BackgroundImage.propTypes = {
    source: _propTypes2.default.string,
    className: _propTypes2.default.string,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
    style: _propTypes2.default.object
};

exports.default = BackgroundImage;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/images/BackgroundImage.js
// module id = 436
// module chunks = 0